import CasesIcon from "@mui/icons-material/CasesOutlined";
import CompareArrowsIcon from "@mui/icons-material/CompareArrowsRounded";
import FeedIcon from "@mui/icons-material/FeedOutlined";
import PersonIcon from "@mui/icons-material/PersonOutlineRounded";
import { Avatar } from "@mui/material";
import type { PredefinedPortalWidgetType } from "@entrilia/shared/api/portalWidgetsTypes";
import MoneyIcon from "@entrilia/shared/icons/MoneyIcon";

interface Props {
  predefinedWidgetType?: PredefinedPortalWidgetType;
}

const widgetIconMap: Record<PredefinedPortalWidgetType, React.ReactNode> = {
  Balance: <MoneyIcon />,
  CashFlows: <CompareArrowsIcon />,
  Portfolio: <CasesIcon />,
  News: <FeedIcon />,
};

const PortalWidgetAvatar = ({ predefinedWidgetType }: Props) => {
  return (
    <Avatar variant="rounded" sx={{ width: 32, height: 32, bgcolor: "background.grey", color: "text.primary" }}>
      {predefinedWidgetType ? widgetIconMap[predefinedWidgetType] : <PersonIcon />}
    </Avatar>
  );
};

export default PortalWidgetAvatar;
